import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const insertBuyerRequirement = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/create`, data);
        return await response.data
    } catch (error) {
        console.log("insert BuyerReq - error", error)
        return handleApiError(error)
    }
}

export const getBuyerRequirementsById = async (buyerReqId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-requirement/${buyerReqId}`);
        return await response.data
    } catch (error) {
        console.log("getBuyerRequirementsById - error", error)
        return handleApiError(error)
    }
}

export const getBuyerRequirementsByCatalogAPIReqId = async (catalogApiRequestId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-requirement/catalog-api/${catalogApiRequestId}`);
        return await response.data
    } catch (error) {
        console.log("getBuyerRequirementsByCatalogAPIReqId - error", error)
        return handleApiError(error)
    }
}

export const getBuyerCompanyAndUserDetailsByBuyerReqId = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/company-user`, data);
        return await response.data
    } catch (error) {
        console.log("getBuyerCompanyAndUserDetailsByBuyerReqId - error", error)
        return handleApiError(error)
    }
}

export  const addNewCompanyFromBuyerReq = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/add-company`, data);
        return await response.data
    } catch (error) {
        console.log("BuyerReq add com - error", error)
        return handleApiError(error)
    }
}

export const duplicateBuyerRequirement = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/duplicate-requirement`, data);
        return await response.data;
    } catch (error) {
        console.log("duplicateBuyerRequirement - error", error)
        return handleApiError(error)
    }
}

export const deleteBuyerRequirement = async (buyerReqId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/delete-requirement/${buyerReqId}`);
        return await response.data;
    } catch (error) {
        console.log("duplicateBuyerRequirement - error", error)
        return handleApiError(error)
    }
}

export const addProductIntoBuyerRequirement = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/add-product`, data);
        return await response.data;
    } catch (error) {
        console.log("addProductIntoBuyerRequirement - error", error)
        return handleApiError(error)
    }
}

export const addRateContractProductIntoBuyerRequirement = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/add-rc-product`, data);
        return await response.data;
    } catch (error) {
        console.log("addRateContractProductIntoBuyerRequirement - error", error)
        return handleApiError(error)
    }
}

export const searchRequirementBuyerDashboard = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/search-buyer-dashboard`, data);
        return await response.data
    } catch (error) {
        console.log("searchRequirementBuyerDashboard - error", error)
        return handleApiError(error)
    }
}

export const getSellerReqsStatusByBuyerReqIds = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/seller-req-status`, data)
        return await response.data
    } catch (error) {
        console.log("getSellerReqsStatusByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const getBuyerQuoteStatusByBuyerReqIds = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/buyer-quote-status`, data)
        return await response.data
    } catch (error) {
        console.log("getBuyerQuoteStatusByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const getBuyerPOStatusByBuyerReqIds = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/buyer-po-status`, data)
        return await response.data
    } catch (error) {
        console.log("getBuyerPOStatusByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const getPOPunchStatusByBuyerReqIds = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/po-punch-status`, data)
        return await response.data
    } catch (error) {
        console.log("getPOPunchStatusByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}


export const getSellerPOStatusByBuyerReqIds = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/seller-po-status`, data)
        return await response.data
    } catch (error) {
        console.log("getSellerPOStatusByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const getBuyerReqsBySmartSearch = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/smart-search`, data);
        return response.data;
    } catch (error) {
        console.log("getBuyerReqsBySmartSearch - error", error)
        return handleApiError(error)
    }
}

export const getRequirementRelatedDetailsByBuyerReqIds = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/req-details`, data)
        return await response.data
    } catch (error) {
        console.log("getRequirementRelatedDetailsByBuyerReqIds - error", error)
        return handleApiError(error)
    }
}

export const getPendingBuyerReq = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/pending-req`, data)
        return await response.data
    } catch (error) {
        console.log("getPendingBuyerReq - error", error)
        return handleApiError(error)
    }
}

export const getReqDetailsForIncrementalReqByBuyerReqId = async (buyerReqId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-requirement/incremental-req/${buyerReqId}`);
        return await response.data
    } catch (error) {
        console.log("getReqDetailsForIncrementalReqByBuyerReqId - error", error)
        return handleApiError(error)
    }
}

export const getLatestBuyerReqByClientPONum = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/latest-incremental-req`, data);
        return await response.data
    } catch (error) {
        console.log("getLatestBuyerReqByClientPONum - error", error)
        return handleApiError(error)
    }
}

export const vrcCheckAtSellerPOCreation = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-requirement/vrc-check-at-sellerpo-creation`, data);
        return await response.data
    } catch (error) {
        console.log("vrcCheckAtSellerPOCreation - error", error)
        return handleApiError(error)
    }
}